var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-bar menu"},[_c('router-link',{staticClass:"menu-item",attrs:{"to":"/admin"}},[_c('div',[_vm._v(_vm._s(_vm.$t('user.title')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }